module.exports = __webpack_public_path__ + "media/icons/shower-b526a4e0.svg";